import React from 'react'

export const PriceListContext = React.createContext({});